import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

export const StyledHeading = styled(Typography)`
  margin-right: 5px;
`

export interface OrderSectionProps {
  className?: string
  name: string
  information: string
}

const OrderSection: React.FC<OrderSectionProps> = ({ className, name, information }) => {
  return (
    <Grid className={className} container item xs={12}>
      <Grid item>
        <StyledHeading variant="body2">
          <strong>{`${name}:`}</strong>
        </StyledHeading>
      </Grid>
      <Grid item>
        <Typography variant="body2">{information}</Typography>
      </Grid>
    </Grid>
  )
}

const StyledOrderSection = styled(OrderSection)`
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  border-bottom: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
  border-top: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
  padding: 15px;

  @media (min-width: 600px) {
    border: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
  }
`
export default StyledOrderSection
